import { SearchOutlined } from '@ant-design/icons';
import { Input } from 'antd';
import { FilterDropdownProps } from 'antd/lib/table/interface';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

import { ssPurple } from '../constants/COLORS';

const TableFilterSearch = (props: FilterDropdownProps) => {
  const [value, setValue] = useState('');

  useEffect(() => {
    if (props.visible) {
      setValue(String(props.selectedKeys));
    }
  }, [props.visible]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Wrapper>
      <Input.Search
        value={value}
        onChange={e => {
          e.persist();
          setValue(e.target?.value || '');
        }}
        onSearch={val => {
          if (val) {
            props.setSelectedKeys([val]);
          } else {
            props.setSelectedKeys([]);
          }
          props.confirm();
        }}
        allowClear
        placeholder="Search..."
        enterButton
      />
    </Wrapper>
  );
};

const Wrapper = styled.div`
  padding: 10px;
`;

export const filterSearchIcon = (filtered: boolean) => {
  if (filtered) {
    return <SearchOutlined style={{ color: ssPurple, fontSize: 14 }} />;
  }

  return <SearchOutlined />;
};

export default TableFilterSearch;
